<div class="cf">
  <div class="d-flex dashboard-header margin-bottom-15">
    <div class="preoperty-dtls d-flex">
      <h2 class="property-hd">
        <span class="text margin-right-10">{{property.Tenant}}</span>
        <span class="status" [ngClass]="{'red':(property.PropertyStatus === 'Closed' || property.PropertyStatus === 'Sold'),
                                                                         'green':property.PropertyStatus === 'Available',
                                                                         'blue':property.PropertyStatus === 'Not Available',
                                                                         'orange':property.PropertyStatus === 'Under Contract','ash':property.PropertyStatus === 'Off-Market','d-orange':property.PropertyStatus === 'Pending Approval'}">
          {{property.PropertyStatus}}

        </span> &nbsp;
        <span *ngIf="timeline.DealMaking <= this.defaultSelectedTimelineId || timeline.Closed <= this.defaultSelectedTimelineId
" href="javascript:void(0);" tooltip="Download Deal Report" class="btn-border  btn-view-portfolio" (click)="generateDealReport()" style="cursor:pointer;display:inline-block;height:25px;">
          <i class="fa fa-download" aria-hidden="true"></i>
        </span> &nbsp;


        <br />

        <span class="property-loc" *ngIf="haveaccesstoviewlocation">{{property.FullAddress && (property.FullAddress.length > 5) ? property.FullAddress:''}}</span>
        <span class="property-loc" *ngIf="!haveaccesstoviewlocation">Confidential</span>
        <br />
        <a href="javascript:void(0);" [ngClass]="{'disable-link':property.IsDeleted}" *ngIf="property.ParentPortfolioName" class="btn-border margin-top-10 btn-view-portfolio" (click)="onViewProperty(property.ParentPortfolioGuid)" style="cursor:pointer;display:inline-block">
          <!--{{property.ParentPortfolioName}}--> View Portfolio
        </a>
      </h2>



      <div *ngIf="!isFromPortfolio" class="dashboard-header-rt ml-auto">
        <ul>
          <li class="ticker" *ngIf="property.TickerSymbol && showMarketData">
            <div>
              <span [style.color]="getColorForStock(price?.regularMarketPrice)" style="font-size:20px;font-weight:500;"> {{price?.regularMarketPrice}}</span> &nbsp;
              <span [style.color]="getColorForStock(price?.regularMarketChange)" style="font-size:13px;font-weight:400;"> {{price?.regularMarketChange}}</span>
              <span [style.color]="getColorForStock(price?.regularMarketChangePercent)">
                ({{price?.regularMarketChangePercent}})
              </span>
            </div>
            <p *ngIf="property.TickerSymbol && price?.quoteSourceName" class="inf-text;" style="max-width: 295px;font-size:13px;">{{price?.symbol}} - {{price?.quoteSourceName}} - Currency in USD As Of {{(price?.regularMarketTime*1000)| date:'MM/dd/yyyy hh:mm a'}}<p>
          </li>
          <li>
            <label class="be-label margin-bottom-0">
              Asking Price
            </label>
            <div class="data" *ngIf="property.Unpriced">
              Unpriced
            </div>
            <div class="data" *ngIf="!property.Unpriced">
              {{(property.IsShowPrice) ? '$ '+(property.Price | number:0) : '--'}}
            </div>
          </li>
          <li>
            <label class="be-label margin-bottom-0">
              NOI
            </label>
            <div class="data">
              {{(property.IsShowPrice) ? '$ '+(property.NetOperatingIncome | number:0) : '--'}}
            </div>
          </li>
          <li>
            <label class="be-label margin-bottom-0">
              Cap Rate
            </label>
            <div class="data" *ngIf="capratetext != 'ZCF'">
              {{ (property.CapRate && property.IsShowPrice) ? (property.CapRate | number : '1.2-2') + ' %' : '--' }}
            </div>
            <div class="data" *ngIf="capratetext == 'ZCF'">
              {{capratetext}}
            </div>
          </li>

        </ul>
      </div>
      <div *ngIf="isFromPortfolio" class="dashboard-header-rt ml-auto">
        <ul>
          <li class="ticker" *ngIf="property.TickerSymbol">
            <div>
              <span [style.color]="getColorForStock(price?.regularMarketPrice?.fmt)" style="font-size:20px;font-weight:500;"> {{price?.regularMarketPrice?.fmt}}</span> &nbsp;
              <span [style.color]="getColorForStock(price?.regularMarketChange?.fmt)" style="font-size:13px;font-weight:400;"> {{price?.regularMarketChange?.fmt}}</span>
              <span [style.color]="getColorForStock(price?.regularMarketChangePercent?.fmt)">
                ({{price?.regularMarketChangePercent?.fmt}})
              </span>
            </div>
            <p *ngIf="property.TickerSymbol && price?.quoteSourceName" class="inf-text;" style="max-width: 295px;font-size:13px;">{{price?.symbol}} - {{price?.quoteSourceName}} - Currency in USD As Of {{(price?.regularMarketTime*1000)| date:'MM/dd/yyyy hh:mm a'}}<p>
          </li>
          <li>
            <label class="be-label margin-bottom-0">
              Asking Price
            </label>
            <div class="data" *ngIf="property.Unpriced">
              Unpriced
            </div>
            <div class="data" *ngIf="!property.Unpriced">
              {{'$ '+(property.Price | number:0)}}
            </div>
          </li>
          <li>
            <label class="be-label margin-bottom-0">
              NOI
            </label>
            <div class="data">
              {{'$ '+(property.NetOperatingIncome | number:0)}}
            </div>
          </li>
          <li>
            <label class="be-label margin-bottom-0">
              Cap Rate
            </label>
            <div class="data" *ngIf="capratetext != 'ZCF'">
              {{ (property.CapRate) ? (property.CapRate | number : '1.2-2') + ' %' : '--' }}
            </div>
            <div class="data" *ngIf="capratetext == 'ZCF'">
              {{capratetext}}
            </div>
          </li>

        </ul>
      </div>
    </div>
  </div>
</div>
<div class="dashboardstyles section-margin" style="padding-bottom:0;">
  <div class="cf timeline-wrap">
    <ul class="wizardstyle2 clearfix">
      <li class="success" (click)="!property.IsDeleted && setMenuID(timeline.BOV)">
        <div class="blueborder-circle">
          <span></span>
        </div>
        <p>BOV</p>
        <!--<p>{{BOVDate | date :'MM/dd/yyyy'}}</p>-->
      </li>
      <li [ngClass]="{'success' : timeline.Premarketing <= this.defaultSelectedTimelineId ,'inactive': timeline.Premarketing > this.defaultSelectedTimelineId}" (click)="!property.IsDeleted && setMenuID(timeline.Premarketing)">
        <div class="blueborder-circle">
          <span></span>
        </div>
        <p>Premarketing</p>
        <!-- <p *ngIf="defaultSelectedTimelineId >= timeline.Premarketing">{{PreMarketingDate | date :'MM/dd/yyyy'}}</p>-->
        <h6></h6>
      </li>
      <li [ngClass]="{'success' : timeline.Marketing <= this.defaultSelectedTimelineId ,'inactive': timeline.Marketing > this.defaultSelectedTimelineId}" (click)="!property.IsDeleted && setMenuID(timeline.Marketing)">
        <div class="blueborder-circle">
          <span></span>
        </div>
        <p>Marketing</p>
        <!--<p *ngIf="defaultSelectedTimelineId >= timeline.Marketing">{{MarketingDate | date :'MM/dd/yyyy'}}</p>-->
      </li>
      <li [ngClass]="{'success' : timeline.DealMaking <= this.defaultSelectedTimelineId ,'inactive': timeline.DealMaking > this.defaultSelectedTimelineId}" (click)="!property.IsDeleted && setMenuID(timeline.DealMaking)">
        <div class="blueborder-circle">
          <span></span>
        </div>
        <p>Deal Making</p>
        <!--<p *ngIf="defaultSelectedTimelineId >= timeline.DealMaking">{{DealMakingDate | date :'MM/dd/yyyy'}}</p>-->
      </li>
      <li [ngClass]="{'success' : timeline.Closed <= this.defaultSelectedTimelineId ,'inactive': timeline.Closed > this.defaultSelectedTimelineId}" (click)="!property.IsDeleted && setMenuID(timeline.Closed)">
        <div class="blueborder-circle">
          <span></span>
        </div>
        <p>Closed</p>
        <!--<p *ngIf="defaultSelectedTimelineId >= timeline.Closed">{{ClosedDate | date :'MM/dd/yyyy'}}</p>-->
      </li>
    </ul>
  </div>
  <ng-container *ngIf="selectedTimelineId == timeline.Marketing">
    <div class="panel-group be-collapse-box" id="accordion" role="tablist" aria-multiselectable="true">
      <div class="panel panel-default">
        <div class="panel-heading" role="tab" id="headingOne">
          <div class="panel-title">
            <a role="button">
              <h2 class="mainhead d-flex">
                <span class="text mr-auto">Marketing Analytics</span>
                <div class="ml-auto pull-right" style="position: relative;top: 3px;">
                  <span *ngIf="prospectTabVisibility && property.PropertyForId == 601" href="javascript:void(0);" tooltip="Download Owner Report" class="btn-border  btn-view-portfolio" (click)="openPreviewModal(previewpopup, 'portfolio-bov-modal')" style="cursor:pointer;display:inline-block;height:25px;">
                    <i class="fa fa-download" aria-hidden="true"></i>
                  </span> &nbsp;
                  <span *ngIf="prospectTabVisibility && property.PropertyForId == 601" href="javascript:void(0);" tooltip="Share Owner Report" class="btn-border btn-view-portfolio margin-right-10" (click)="openPropertyShareModal(previewpopup, 'portfolio-bov-modal')" style="cursor:pointer;display:inline-block;height:25px;">
                    <i class="icofont icofont-share icon" aria-hidden="true"></i>
                  </span>
                </div>
                <i class="fa fa-angle-right margin-right-10" aria-hidden="true" data-toggle="collapse" data-parent="#accordion" href="#collapseOne" aria-expanded="true" aria-controls="collapseOne"></i>
              </h2>

            </a>

          </div>
        </div>
        <div id="collapseOne" class="panel-collapse collapse in" role="tabpanel" aria-labelledby="headingOne">
          <div class="panel-body">
            <div class="d-flex align-items-center">
              <!--<h3 class="margin0 bluelabel " style="font-size: 16px; font-weight: 600;color: #053d5d;margin-bottom:5px;">Sub heading</h3>-->

            </div>
            <app-prospects [propertyId]="propertyId" [isFromDashboard]="true" [isFromPortfolio]="isFromPortfolio" [property]="property" (loadProspect)="loadProspect($event)"></app-prospects>
          </div>
        </div>
      </div>
    </div>
    <div class="no-inner-border">
      <property-offers-list [fromPropertyDashboard]="1" [propertyGuid]="propertyGuid" [IsPDeleted]="property.IsDeleted" (statusChange)="offerStatusChange($event)" (placeOffer)="placeOffer($event)" [propertyStatus]="property.PropertyStatusId" [IsArchive]="IsArchive" [isFromPortfolio]="isFromPortfolio"></property-offers-list>
    </div>
    <app-p-dashboard-charts [IsPortfolio]="property.IsPortfolio" [isFromPortfolio]="isFromPortfolio" [propertyId]="property.Id"></app-p-dashboard-charts>
  </ng-container>
  <ng-container *ngIf="selectedTimelineId == timeline.Premarketing">
    <app-property-premarketing [propertyId]="property.Id"></app-property-premarketing>
  </ng-container>
  <ng-container *ngIf="selectedTimelineId == timeline.BOV">
    <app-bov [propertyId]="property.Id"></app-bov>
  </ng-container>
  <ng-container *ngIf="selectedTimelineId == timeline.DealMaking || selectedTimelineId == timeline.Closed">
    <app-property-deal-making [propertyId]="property.Id" [offerGuid]="property.OfferGuid"></app-property-deal-making>
  </ng-container>

  <ng-template #previewpopup>
      <app-sort-preview [propertyGuid]="propertyGuid" [propertyId]="property.Id" [isFromPortfolio]="IsFromPortfolio" (close)="onClose()" (save)="onSave($event)" [isShareReport]="isShareReport"></app-sort-preview>
    </ng-template>

  <ng-template #sharepopup>
    <app-sort-preview [propertyGuid]="propertyGuid" [propertyId]="property.Id" [isFromPortfolio]="IsFromPortfolio" (close)="onClose()" (save)="onSave($event)" [isShareReport]="isShareReport"></app-sort-preview>
  </ng-template>
</div>
